export * from './ProductDetailSetting';
export { ProductDetailSetting as default } from './ProductDetailSetting';
